import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/shell.css';
import './styles/components.css';
import './styles/density.css';
import { App } from './app/App';
import { captureInstallPrompt, registerServiceWorker } from './app/pwa';
import { applyRootAttributes, useUi } from './app/store';
import { preloadMarkdown } from './ui/MarkdownStream';

// Set theme/density before first paint to avoid a flash.
applyRootAttributes(useUi.getState());
captureInstallPrompt();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// After the first screen: the offline shell worker (production only) and the Markdown renderer.
const idle = (fn: () => void) => ('requestIdleCallback' in window ? window.requestIdleCallback(fn, { timeout: 4000 }) : setTimeout(fn, 1500));
window.addEventListener('load', () => {
  void registerServiceWorker();
  idle(() => void preloadMarkdown());
});
